import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule, Provider, Type } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatBadgeModule } from "@angular/material/badge";
import { IonicModule } from "@ionic/angular";
import { CalaoAvatarModule } from "../../modules/avatar/calao-avatar.module";
import { BrowserModule } from "../../modules/browser/browser.module";
import { ConversationsModule } from "../../modules/conversations/conversations.module";
import { FilterModule } from "../../modules/filter/filter.module";
import { LiveModule } from "../../modules/live/live.module";
import { ModalModule } from "../../modules/modal/modal.module";
import { RoutingModule } from "../../modules/routing/routing.module";
import { SpinnerModule } from "../../modules/spinner/spinner.module";
import { TabsModule } from "../../modules/tabs/tabs.module";
import { VirtualScrollModule } from "../../modules/virtual-scroll/virtual-scroll.module";
import { PipeModule } from "../../pipes/pipes.module";
import { ContactsService } from "../../services/contacts.service";
import { GalleryModule } from "../gallery/gallery.module";
import { SearchModule } from "../search/search.module";
import { ToolbarModule } from "../toolbar/toolbar.module";
import { AiConversationSummaryModalComponent } from "./aiConversationSummaryModal/ai-conversation-summary-modal.component";
import { AttachmentsPopoverComponent } from "./attachmentsPopover/attachmentsPopover.component";
import { ConversationComponent } from "./conversation.component";
import { ConversationTypeToggleComponent } from "./conversationTypeToggle/conversation-type-toggle.component";
import { ConversationEditComponent } from "./edit/conversationEdit.component";
import { CanLeaveConversationEdit } from "./edit/guards/canLeaveConversationEdit.guard";
import { ConversationsListComponent } from "./list/conversations-list.component";
import { MailDetailModalComponent } from "./mailDetailModal/mail-detail-modal.component";
import { ConversationTabComponent } from "./tab/conversation-tab.component";

const modules: (Type<any> | ModuleWithProviders<any>)[] = [
	IonicModule,
	CommonModule,
	ToolbarModule,
	PipeModule,
	CalaoAvatarModule,
	GalleryModule,
	FormsModule,
	SearchModule,
	MatBadgeModule,
	SpinnerModule,
	TabsModule,
	VirtualScrollModule,
	LiveModule,
	ModalModule,
	RoutingModule.forRoot({ defaultRoute: "conversations" }),
	BrowserModule,
	ConversationsModule,
	FilterModule
];
const components: Type<any>[] = [
	ConversationComponent,
	ConversationsListComponent,
	ConversationEditComponent,
	ConversationTabComponent,
	AttachmentsPopoverComponent,
	AiConversationSummaryModalComponent,
	MailDetailModalComponent,
	ConversationTypeToggleComponent
];
const providers: Provider[] = [ContactsService, CanLeaveConversationEdit];

/** Module de gestion des conversations. */
@NgModule({
	imports: modules,
	exports: components,
	declarations: components,
	providers: providers
})
export class ConversationModule {}
